import React, { useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Grid, Button, Typography, TextField, Box, FormControl, InputLabel, Modal, Select, MenuItem, FormHelperText, AccordionDetails, AccordionSummary, Accordion } from "@mui/material";
import { useBulkUploadMutation } from "../../../app/services/memberServices";
import { toast } from "react-toastify";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Spinner from '../../../Component/spinner/spinner'
import individualTeacher from "../../../assets/excel/Individual_Teacher_Membership.xlsx";
import dualTeacher from "../../../assets/excel/Dual_Teacher_Membership.xlsx";
import student from "../../../assets/excel/Individual_Student_Membership.xlsx";
import institution from "../../../assets/excel/Institutional_Membership.xlsx";
import corporate from "../../../assets/excel/Corporate_Supporters_Membership.xlsx";

const planType = [
    {
        planName: 'Individual Teacher',
        planId: '0'
    },
    {
        planName: 'Dual Teacher',
        planId: '4'
    },
    {
        planName: 'Student',
        planId: '1'
    },
    {
        planName: 'Institutional',
        planId: '2'
    },
    {
        planName: 'Corporate Supporter',
        planId: '3'
    },
]
const accordionStyle = {
    bgcolor: "#f5f5f5", // light gray background
    border: "1px solid #ddd",
    "& .MuiTypography-root": {
        color: "#333"
    },
    "&:hover": {
        bgcolor: "#e0e0e0" // darker on hover
    }
}

const MemberBulkUpload = () => {
    const [bulkUpload] = useBulkUploadMutation();
    const [selectedPlan, setSelectedPlan] = useState("");
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false)

    const {
        control,
        handleSubmit,
        setError,
        setValue,
        clearErrors,
        formState: { errors },
    } = useForm({
        mode: "onChange",
        defaultValues: {
            type: '',
            file: null, // ✅ Default should be `null` instead of an empty string
        },
    });


    //validTation for the excel file
    const validateFile = (file) => {
        if (!file) return "File is required!";

        const allowedTypes = [
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
            "application/vnd.ms-excel", // .xls
        ];
        if (!allowedTypes.includes(file.type)) return "Only Excel files are allowed!";
        return true;
    };

    // Mapping plans to their respective Excel file URLs
    const fileMap = [
        { name: "Individual Teacher", link: individualTeacher, filename: "Individual_Teacher_Membership.xlsx" },
        { name: "Dual Teacher", link: dualTeacher, filename: "Dual_Teacher_Membership.xlsx" },
        { name: "Student", link: student, filename: "Individual_Student_Membership.xlsx" },
        { name: "Institutional", link: institution, filename: "Institutional_Membership.xlsx" },
        { name: "Corporate Supporter", link: corporate, filename: "Corporate_Supporters_Membership.xlsx" },
    ];

    const handleDownload = () => {
        const selectedPlanObject = fileMap.find(
            (plan) => plan.name.trim() === selectedPlan.trim()
        );
        if (!selectedPlanObject) return;
        const link = document.createElement("a");
        link.href = selectedPlanObject.link; // imported asset URL
        link.download = selectedPlanObject.filename;// optional filename
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        handleClose();
    }

    // Member bulkupload integration
    const uploadMember = (data) => {
        const formData = new FormData();
        formData.append("file", data.file);
        formData.append("type", data.type);
        setLoading(true)
        bulkUpload(formData).then((res) => {
            setLoading(false)
            if (res?.data?.status) {
                toast.success(res?.data?.message)
                setValue("file", "");
                setValue("type", "");
            } else {
                setValue("file", "");
                setValue("type", "");
                toast.error(res?.error?.data?.message)
            }
        }).catch((error) => {
            setValue("file", "");
            setValue("type", "");
            setLoading(false)
            console.error("Upload Error:", error);
        });
    };

    const handleClose = () => {
        setSelectedPlan('')
        setOpen(false)
    }
    const handleOpen = () => {
        setOpen(true);
    };
    //Modal usage
    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        maxWidth: 400,
        minWidth: 300,
        height: '30%',
        bgcolor: "background.paper",
        boxShadow: 24,
        padding: 4,
        overflowY: 'scroll',
        "&::-webkit-scrollbar": {
            display: 'none'
        },
    };

    return (
        <Box>
            <div className="pt-5 ">
                <div className="chapter-heading">
                    <h2 className="text-center title-font text-light py-3 mt-1">
                        Bulk Upload New Members
                    </h2>
                </div>
            </div>

            <div className="p-3 p-md-5 overallpadding d-flex flex-column align-items-center">
                <div className="text-center w-100">
                    <p><button
                        style={{
                            textDecoration: "underline",
                            backgroundColor: "transparent",
                            border: "none",
                            color: "var(--all-menus-color)",
                            cursor: "pointer",
                            padding: 0,
                        }}
                        onClick={handleOpen}
                    >
                        Download
                    </button> the excel sheet and fill out the membership details for the bulk upload.</p>
                </div>

                {loading ? <Spinner></Spinner> :
                    <form onSubmit={handleSubmit(uploadMember)} className="mt-4 w-100">
                        <Grid container spacing={3} justifyContent="center">
                            <Grid item xs={12} md={4}>
                                <FormControl fullWidth style={{ margin: "0 auto" }} error={!!errors.type}                            >
                                    <InputLabel className="text-dark">Membership Plan</InputLabel>
                                    <Controller
                                        name="type"
                                        control={control}
                                        defaultValue=""
                                        rules={{
                                            required: "Please select a membership type", // Validation rule
                                        }}
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                label={
                                                    <Typography className="text-dark">
                                                        Membership Plan <span style={{ color: "red" }}>*</span>
                                                    </Typography>
                                                }
                                                value={field.value}
                                                className="bg-white"
                                                onChange={(e) => {
                                                    field.onChange(e);
                                                }}
                                            >
                                                <MenuItem value="">
                                                    <em>Select MembershipType</em>
                                                </MenuItem>
                                                {planType.map((plan, index) => (
                                                    <MenuItem key={index} value={plan.planId}>
                                                        {plan.planName}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        )}
                                    />
                                    {errors.type && (
                                        <FormHelperText>{errors.type.message}</FormHelperText>
                                    )}

                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Controller
                                    name="file"
                                    control={control}
                                    rules={{
                                        required: "Please select an excel file",
                                        validate: validateFile,
                                    }}
                                    render={({ field: { onChange, ref } }) => (
                                        <TextField
                                            inputRef={ref}
                                            InputProps={{ type: "file" }}
                                            fullWidth
                                            InputLabelProps={{ shrink: true }}
                                            label={
                                                <Typography className="text-dark">
                                                    Upload File <span style={{ color: "red" }}>*</span>
                                                </Typography>
                                            }
                                            inputProps={{ accept: ".xls,.xlsx" }}
                                            error={!!errors?.file}
                                            helperText={errors?.file?.message}
                                            onChange={(e) => {
                                                const fileList = e.target.files;

                                                if (!fileList || fileList.length === 0) {
                                                    setError("file", { message: "Please select a file!" });
                                                    return;
                                                }

                                                const file = fileList[0];
                                                const validationResult = validateFile(file);

                                                if (validationResult === true) {
                                                    onChange(file);
                                                    clearErrors("file");
                                                } else {
                                                    e.target.value = "";
                                                    setError("file", { message: validationResult });
                                                }
                                            }}
                                        />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12} md={2} className="mt-2 justify-content-end align-items-center d-flex">
                                <Button variant="contained" className="menus-color" type="submit">
                                    Upload
                                </Button>
                            </Grid>
                            <Grid item xs={10} md={10} >
                                <Typography variant="body2" color="error" align='justify'>
                                    Note: Please complete all the required fields in the Excel sheet according to the helper notes provided for each membership type. Make sure to select all dates using the spreadsheet’s date picker — do not enter dates manually.
                                </Typography>
                            </Grid>
                            <Grid item xs={12} md={10}>

                                {/* Teacher, Dual & Student */}
                                <Accordion>
                                    <AccordionSummary sx={accordionStyle} expandIcon={<ExpandMoreIcon />}>
                                        <Typography variant="body2" fontSize={18} fontWeight={500}>
                                            Mandatory fields for Individual Teacher, Dual Teacher & Student Membership
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul className="list-unstyled">
                                            <li>Salutation</li>
                                            <li>Full Name</li>
                                            <li>Date of Birth</li>
                                            <li>Gender</li>
                                            <li>Address, City, Pincode, State, Country</li>
                                            <li>Email Address, Mobile No</li>
                                            <li>Plan Name, Plan Type, Amount, Currency</li>
                                            <li>Plan Start Date, Plan End Date</li>
                                            <li>isPaid, Payment Type</li>
                                            <li>Dual No (only for Dual Teachers) same number for both members</li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>

                                {/* Institution */}
                                <Accordion>
                                    <AccordionSummary sx={accordionStyle} expandIcon={<ExpandMoreIcon />}>
                                        <Typography variant="body2" fontSize={18} fontWeight={500}>
                                            Mandatory fields for Institutional Membership
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul className="list-unstyled">
                                            <li>Name of Institution</li>
                                            <li>Address, City, Pincode, State, Country</li>
                                            <li>Email Address, Mobile No</li>
                                            <li>Plan Name, Plan Type, Amount, Currency</li>
                                            <li>Plan Start Date, Plan End Date</li>
                                            <li>isPaid, Payment Type</li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>

                                {/* Corporate */}
                                <Accordion>
                                    <AccordionSummary sx={accordionStyle} expandIcon={<ExpandMoreIcon />}>
                                        <Typography variant="body2" fontSize={18} fontWeight={500}>
                                            Mandatory fields for Corporate Supporter Membership
                                        </Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <ul className="list-unstyled">
                                            <li>Name of Organisation</li>
                                            <li>Address, City, Pincode, State, Country</li>
                                            <li>Email Address, Mobile No</li>
                                            <li>Plan Name, Plan Type, Amount, Currency</li>
                                            <li>Plan Start Date, Plan End Date</li>
                                            <li>isPaid, Payment Type</li>
                                        </ul>
                                    </AccordionDetails>
                                </Accordion>
                            </Grid>
                        </Grid>
                    </form>}
            </div>
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style} className="d-flex w-100 align-items-center flex-column gap-3">
                    <h4 className="alata-regular fs-3 title-font" style={{ color: "#104e29" }}>Download Excel</h4>

                    <Grid container rowSpacing={2} columnSpacing={3}>
                        <Grid item xs={12} md={12} lg={12}>
                            <FormControl fullWidth style={{ maxWidth: 400, margin: "0 auto" }} >
                                <InputLabel className="text-dark">Membership Plan</InputLabel>
                                <Select label={
                                    <Typography className="text-dark">
                                        Membership Plan
                                    </Typography>
                                } value={selectedPlan} onChange={(e) => setSelectedPlan(e.target.value)}>
                                    {fileMap.map((plan, index) => (
                                        <MenuItem key={index} value={plan.name}>
                                            {plan.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="d-flex gap-3 justify-content-center mt-3 pb-3">
                        <Button
                            variant="outlined"
                            color="error"
                            className="rounded-0"
                            onClick={handleClose}
                        >
                            cancel
                        </Button>
                        <Button variant="contained" className="ms-3 menus-color" onClick={handleDownload} disabled={!selectedPlan}>
                            Download Excel
                        </Button>
                    </div>

                </Box>
            </Modal>
        </Box >
    );
};

export default MemberBulkUpload;

